// Estela de iconos siguiendo al ratón en el modo fondo personalizado, portada del prototipo Figma Make
// "Parrilla XMAS" (StarCursor): el icono subido sale del cursor, flota, gira y se desvanece.
// Configuración en Theme settings > Custom background mode > Cursor, que llega vía window.brownieCustomBg.config
// (snippets/custom-bg-mode-init.liquid). Estilos: scss/components/_custom-bg-switch.scss
(function () {
  const customBg = window.brownieCustomBg;
  if (!customBg || !customBg.config) return;

  const config = customBg.config;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");

  // ---------------------------------------------------------------------------
  // Estela de iconos en el cursor
  // ---------------------------------------------------------------------------
  let canvas = null;
  let ctx = null;
  let trailImage = null;
  let particles = [];
  let rafId = 0;

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles = particles.filter((p) => p.life > 0);

    for (const p of particles) {
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.02;
      p.life -= 0.03;

      const size = p.size * p.life;
      ctx.save();
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.shadowColor = "rgba(255, 255, 255, 0.7)";
      ctx.shadowBlur = 6;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.life * 4);
      ctx.drawImage(trailImage, -size / 2, -size / 2, size, size);
      ctx.restore();
    }

    // Sin partículas vivas se para el bucle; el siguiente mousemove lo vuelve a arrancar
    rafId = particles.length ? requestAnimationFrame(loop) : 0;
  }

  function onMouseMove(e) {
    const maxSize = Number(config.trailSize) || 18;

    for (let i = 0; i < 3; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = Math.random() * 1.5 + 0.5;
      particles.push({
        x: e.clientX,
        y: e.clientY,
        vx: Math.cos(angle) * speed * 0.4,
        vy: Math.sin(angle) * speed * 0.4 - 0.6,
        life: 1,
        // Entre 1/3 y el 100% del tamaño máximo (con 18px → 6-18px, como el prototipo)
        size: maxSize / 3 + Math.random() * (maxSize * 2 / 3),
      });
    }
    if (!rafId) rafId = requestAnimationFrame(loop);
  }

  function startTrail() {
    canvas = document.createElement("canvas");
    canvas.className = "custom-bg-trail";
    canvas.setAttribute("aria-hidden", "true");
    ctx = canvas.getContext("2d");
    resizeCanvas();
    document.body.appendChild(canvas);

    window.addEventListener("resize", resizeCanvas);
    window.addEventListener("mousemove", onMouseMove, { passive: true });
  }

  function createTrail() {
    if (canvas || trailImage || !config.trail || !config.trailImage || reducedMotion.matches || !finePointer.matches) return;

    // Se espera a que cargue el icono para no dibujar partículas vacías
    trailImage = new Image();
    trailImage.onload = () => {
      if (trailImage && customBg.isOn()) startTrail();
    };
    trailImage.src = config.trailImage;
  }

  function removeTrail() {
    trailImage = null;
    if (!canvas) return;
    window.removeEventListener("resize", resizeCanvas);
    window.removeEventListener("mousemove", onMouseMove);
    cancelAnimationFrame(rafId);
    rafId = 0;
    particles = [];
    canvas.remove();
    canvas = null;
    ctx = null;
  }

  // ---------------------------------------------------------------------------
  function update(isOn) {
    if (isOn) {
      createTrail();
    } else {
      removeTrail();
    }
  }

  document.addEventListener("custom-bg-mode:change", (e) => update(e.detail.isOn));
  update(customBg.isOn());
})();
